import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";

export const sendAnalyticsEventOpenModal = (modalId: string): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.MODAL,
		action: "openModal",
		params: [modalId],
	});
};

export const sendAnalyticsEventCloseModal = (modalId: string): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.MODAL,
		action: "closeModal",
		params: [modalId],
	});
};
